import React from 'react';
import { formatPowerAutoUnit, formatValue } from '../../../../utils';
import * as s from './styled-pracas-mapa';

// Cards "AGORA" (geracao/consumo + vazao) sobrepostos no rodape-central
// do mapa SO em tela cheia (modo TV no CCO). Reaproveita os mesmos
// agregados do redux (primeiroNivel.uchas / .ebas) que o card
// VisaoGeralUchasEbas usa no dashboard normal — assim os numeros batem.

const hasMetricValue = (v) => v !== undefined && v !== null;

// Icones line-style (Lucide) — zap (potencia) e droplet (vazao).
const ZapIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
  </svg>
);
const DropletIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0L12 2.69z" />
  </svg>
);

// Um card por tipo. tipo 'uchas' (laranja, "Ontime Running") ou
// 'ebas' (azul, "Potencia"). data = objeto agregado do redux.
const LiveCard = ({ tipo, data }) => {
  const color = tipo === 'uchas' ? 'orange' : 'blue';
  const powerLabel = tipo === 'uchas' ? 'Ontime Running' : 'Potência';
  const powerRaw = tipo === 'uchas' ? data.onTime : data.potencia;
  const hasPower = hasMetricValue(powerRaw);
  // UCHA gera com sinal negativo na convencao do backend — exibimos o
  // modulo (positivo) e em verde, igual ao card do dashboard.
  const powerValue = hasPower
    ? formatPowerAutoUnit(
        tipo === 'uchas'
          ? Math.abs(Number(powerRaw) || 0)
          : powerRaw,
        'kW',
      )
    : '—';
  const generating = hasPower && Number(powerRaw) !== 0;
  const total = data.total || 0;
  const metaPrefix = tipo === 'uchas' ? 'Geração' : 'Bombeamento';

  return (
    <s.LiveTotalCard color={color}>
      <s.LiveTotalTitle>
        <s.LiveTotalChip color={color}>
          total de {total} {tipo}
        </s.LiveTotalChip>
        <s.LiveTotalMeta>
          {metaPrefix} · <b>atualização contínua</b>
        </s.LiveTotalMeta>
      </s.LiveTotalTitle>
      <s.LiveTotalLabel>Agora</s.LiveTotalLabel>
      <s.LiveTotalPair>
        <s.LiveTotalMetric>
          <s.LiveTotalHeader color={color}>
            <ZapIcon />
            {powerLabel}
          </s.LiveTotalHeader>
          <s.LiveTotalValue $positive={generating}>
            {powerValue}
          </s.LiveTotalValue>
        </s.LiveTotalMetric>
        <s.LiveTotalSep aria-hidden="true" />
        <s.LiveTotalMetric>
          <s.LiveTotalHeader color={color}>
            <DropletIcon />
            Vazão
          </s.LiveTotalHeader>
          <s.LiveTotalValue color={color}>
            {hasMetricValue(data.vazao)
              ? `${formatValue(data.vazao)} l/s`
              : '—'}
          </s.LiveTotalValue>
        </s.LiveTotalMetric>
      </s.LiveTotalPair>
    </s.LiveTotalCard>
  );
};

const FullscreenLiveTotals = ({ uchas, ebas }) => {
  const hasUchas = uchas && (uchas.total || hasMetricValue(uchas.onTime));
  const hasEbas = ebas && (ebas.total || hasMetricValue(ebas.potencia));
  if (!hasUchas && !hasEbas) return null;

  return (
    <s.FullscreenLiveTotals>
      {hasUchas && <LiveCard tipo="uchas" data={uchas} />}
      {hasEbas && <LiveCard tipo="ebas" data={ebas} />}
    </s.FullscreenLiveTotals>
  );
};

export default FullscreenLiveTotals;
